export default __webpack_public_path__ + "static/media/next.e2f871a3.svg";